export default "__VITE_ASSET__a9af5676__"